export default __webpack_public_path__ + "static/media/Eternal Faith Boots.fddd8ca1.jpg";